// Tonight's city: a first visit to the home page lands on it (site/js/app.js), and the city picker tags it. It changes
// at the visitor's own midnight, it's the same city for everyone on a given date, and one night's city is in another
// region (the registry's `region`) than the next one's. Pure (no DOM, no timers), so node can test it: node --test tests/

// The nights in turn, round and round. A new city goes in where the regions still alternate, at the end if it can
// (tests/tonight.test.mjs checks every city is here and no two nights in a row share a region). A city that leaves the
// registry is skipped, and one missing here comes after these, so the schedule never breaks (it shifts once when the
// number of cities changes).
export const ORDER = [
  'tokyo', 'paris', 'new-york', 'istanbul', 'sydney', 'london', 'hong-kong', 'rome', 'rio', 'amsterdam', 'dubai',
  'cape-town', 'prague', 'seoul', 'san-francisco', 'madrid', 'bangkok', 'hamburg', 'vancouver', 'budapest', 'singapore', 'munich',
  'new-delhi', 'lisbon', 'mexico-city', 'copenhagen', 'cairo', 'berlin', 'osaka', 'athens', 'seattle', 'florence', 'miami', 'dublin',
  'chicago', 'stockholm', 'las-vegas', 'kyoto', 'venice', 'marrakech', 'buenos-aires', 'barcelona',
  'taipei', 'toronto', 'chongqing', 'new-orleans', 'melbourne', 'boston', 'bali', 'los-angeles', 'honolulu',
  'agra', 'porto', 'havana', 'kuala-lumpur', 'reykjavik', 'almaty', 'warsaw', 'manila', 'valletta', 'portland',
  'helsinki', 'ho-chi-minh-city', 'cartagena', 'nairobi', 'auckland', 'winnipeg',
];
const DAY = 86400000, START = Date.UTC(2026, 9, 1);   // 2026-10-01 is ORDER[0]'s night

/** Whole days from START to the visitor's calendar date (their clock's day, so daylight saving time moves nothing) */
export const dayIndex = date => Math.round((Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - START) / DAY);

/** The id of tonight's city among `ids` (the registry's) on `date`'s local day, or null without any */
export function tonightCity(date, ids) {
  const order = [...ORDER.filter(id => ids.includes(id)), ...ids.filter(id => !ORDER.includes(id))];
  if (!order.length) return null;
  return order[((dayIndex(date) % order.length) + order.length) % order.length];
}

/** With ?tonight=<id> (a test) that city is tonight's, ?tonight=off leaves none (null); anything else, the date's. */
export function tonightOf(param, date, ids) {
  if (param != null && ids.includes(param)) return param;
  if (param != null && /^(off|false|0|no|none)$/i.test(param)) return null;
  return tonightCity(date, ids);
}
